<div class="right-side p-5">
  <h2>User Manual</h2>
  <div class="section">
    <form [formGroup]="pdfForm" class="upload-form">

      <!-- MSME-only -->
      <!--<ng-container *ngIf="userType === 'MSME'">
        <button type="button" class="btn btn-primary btn-sm mt-1" (click)="viewManual('MSME')">
          <i class="bi bi-eye"></i> MSME View
        </button>
      </ng-container>-->

      <!-- IA-only -->
      <!--<ng-container *ngIf="userType === 'IA'">
        <button type="button" class="btn btn-primary btn-sm mt-1" (click)="viewManual('IA')">
          <i class="bi bi-eye"></i> IA View
        </button>
      </ng-container>-->

      <!-- MSSIDC: Show both -->
      <ng-container *ngIf="userType === 'MSSIDC'">
        <button type="button" class="btn btn-primary btn-sm mt-1 me-2" (click)="viewManual('MSME')">
          <i class="bi bi-eye"></i> MSME View
        </button>
        <button type="button" class="btn btn-primary btn-sm mt-1" (click)="viewManual('IA')">
          <i class="bi bi-eye"></i> IA View
        </button>
      </ng-container>

    </form>
  </div>
</div>

